/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { SubscriptionList, Subscription } from "../../data/interfaces";

export const FETCH_SUBSCRIPTIONS_REQUEST = 'FETCH_SUBSCRIPTIONS_REQUEST';
export const FETCH_SUBSCRIPTIONS_SUCCESS = 'FETCH_SUBSCRIPTIONS_SUCCESS';
export const FETCH_SUBSCRIPTIONS_FAILURE = 'FETCH_SUBSCRIPTIONS_FAILURE';

export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_FAILURE = 'UPDATE_SUBSCRIPTION_FAILURE';

export const CREATE_SUBSCRIPTIONS_REQUEST = 'CREATE_SUBSCRIPTIONS_REQUEST';
export const CREATE_SUBSCRIPTIONS_SUCCESS = 'CREATE_SUBSCRIPTIONS_SUCCESS';
export const CREATE_SUBSCRIPTIONS_FAILURE = 'CREATE_SUBSCRIPTIONS_FAILURE';

export const DELETE_SUBSCRIPTIONS_REQUEST = 'DELETE_SUBSCRIPTIONS_REQUEST';
export const DELETE_SUBSCRIPTIONS_SUCCESS = 'DELETE_SUBSCRIPTIONS_SUCCESS';
export const DELETE_SUBSCRIPTIONS_FAILURE = 'DELETE_SUBSCRIPTIONS_FAILURE';

export interface SubscriptionsAction {
    type: typeof FETCH_SUBSCRIPTIONS_REQUEST | typeof FETCH_SUBSCRIPTIONS_SUCCESS | typeof FETCH_SUBSCRIPTIONS_FAILURE
    | typeof UPDATE_SUBSCRIPTION_REQUEST | typeof UPDATE_SUBSCRIPTION_SUCCESS | typeof UPDATE_SUBSCRIPTION_FAILURE
    | typeof DELETE_SUBSCRIPTIONS_REQUEST | typeof DELETE_SUBSCRIPTIONS_SUCCESS | typeof DELETE_SUBSCRIPTIONS_FAILURE,
    payload?: SubscriptionList | Subscription | string
}

export interface CreateSubscriptionsAction {
    type: typeof CREATE_SUBSCRIPTIONS_REQUEST | typeof CREATE_SUBSCRIPTIONS_SUCCESS | typeof CREATE_SUBSCRIPTIONS_FAILURE,
    payload?: Subscription | string
}
